module.exports = __webpack_public_path__ + "static/img/12.babde28.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/3/zh/12.png
// module id = r2bi
// module chunks = 0